<template>
  <div class="bg-center bg-no-repeat bg-cover items-center" :style="{ backgroundImage: 'url(' + backgroundImage + ')' }">
    <div class="container mx-auto">
      <div class="h-full min-h-screen flex">
        <div class="m-auto w-full">
          <div class="flex justify-center">
            <div class="w-full rounded-lg border-t-2 border-green-600 shadow max-w-md bg-white p-5">
              <div class="justify-center mb-8 md:flex items-center">
                <img :src="logoImage" :alt="appName" class="w-20 h-20 rounded-md" />
              </div>
              <template v-if="isActive">
                <p class="text-gray-700">
                  {{ $t('You are just logged in successfully please go to home') }}
                </p>
                <br /><br />
                <router-link to="/" class="btn btn-green mt-2">{{ $t('Home') }}</router-link>
              </template>
              <template v-else>
                <router-view />
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'auth',
  metaInfo() {
    return {
      titleTemplate: `%s - ${this.appName}`,
    };
  },
  data() {
    return {
      isActive: false,
    };
  },
  watch: {
    activeUser(user) {
      setTimeout(() => {
        this.isActive = user.id > 0;
      }, 1500);
    },
  },
  computed: {
    appName() {
      return this.$store.getters['app/getAppName'];
    },
    logoImage() {
      return this.$store.getters['app/getAppLogo'];
    },
    backgroundImage() {
      return this.$store.getters['app/getAppBackground'];
    },
    activeUser() {
      return this.$store.getters['app/getUser'];
    },
  },
};
</script>
